
import axios from "axios"

const ONE_MINUTE = 180000 / 2

const TIMEOUT = ONE_MINUTE * 4
const MAX_NUMBER_OF_CACHES = 200

const isOutdated = ({createdAt}, timeout = TIMEOUT) => (new Date().getTime() - createdAt) > timeout

const promises = {}

export default {
  state: () => ({
    cache: {},
    keepingTrack: {},
  }),
  mutations: {
    removeCache(state, key) {
      const obj = {...state.cache}
      delete obj[key]
      state.cache = obj
    },
    clearCache(state) {
      console.log("clear")
      state.cache = {}
    },
    deleteCache(state, {include}) {
      const newCache = {...state.cache}
      Object.keys(state.cache).forEach(key => {
        if (include.includes(key)) {
          delete newCache[key]
        }
      })
      state.cache = newCache
    },
  },
  actions: {
    keepTrackOfEndpoint({ dispatch, state }, {endpoint, params}) {
      const key = endpoint + JSON.stringify(params)
      if (state.keepingTrack[key]) return;

      dispatch("cachedGet", {endpoint, params})
      setInterval(() => {
        dispatch("cachedGet", {endpoint, params})
      }, TIMEOUT + 500)

      state.keepingTrack[key] = true
    },

    cacheResult({state, commit}, {key, data, timeout}) {
      state.cache[key] = {
        data,
        createdAt: new Date().getTime(),
      }

      Object.keys(state.cache).forEach(key => {
        if (isOutdated(state.cache[key], timeout)) {
          commit("removeCache", key)
        }
      })

      const keys = Object.keys(state.cache)
      if (keys.length > MAX_NUMBER_OF_CACHES) {
        let oldestCacheKey
        keys.forEach(key => {
          if (!oldestCacheKey || state.cache[key].createdAt < state.cache[oldestCacheKey].createdAt) {
            oldestCacheKey = key
          }
        })
        commit("removeCache", oldestCacheKey)
      }
    },
    getCache({ state }, {key, timeout}) {
      if (
        !state.cache[key] ||
        isOutdated(state.cache[key], timeout)
      ) return null
      return state.cache[key].data
    },
    clearCacheSearch({ state, commit }, search) {
      console.log("cache", search, { ...state.cache })
      Object.keys(state.cache).forEach(key => {
        if (key.includes(search)) {
          commit("removeCache", key)
        }
      })
      console.log("cache", search, { ...state.cache })
    },
    async cachedGet({ dispatch }, {endpoint, params, clearCacheSearch, fresh, timeout, headers}) {
      const key = endpoint + JSON.stringify(params)
      if (fresh && clearCacheSearch) {
        dispatch('clearCacheSearch', clearCacheSearch)
      }
      if (promises[key] && !fresh) return await promises[key]
      promises[key] = new Promise(async (solve, reject) => {
        try {
          const cachedData = await dispatch("getCache", {key, timeout})
          if (!cachedData || fresh) {
            const data = await axios.get(endpoint, { ...params, headers: { ...((params && params.headers) || {}), ...headers } })
            dispatch("cacheResult", {key, data, timeout})
            solve(data)
          }

          solve(cachedData)
        } catch (err) {
          reject(err)
        }
      })
      const res = await promises[key]
      delete promises[key]
      return res
    },
  },
}
